
import { NotDisturbModeScreenNavigationProps } from "./types"
import React from "react"
import NotificationBell from "./notification-bell-screen"
import { PageRoot } from "~screens/page-root"


// 通知铃声
const NotificationBellScreen: React.FC<NotDisturbModeScreenNavigationProps> = ({ route }) => {
  return (
    <PageRoot>
      <NotificationBell route={route}/>
    </PageRoot>
  )
}

export default NotificationBellScreen
